import Vue from "vue";
import Component from "vue-class-component";

import AutoCompleteForm from "./shared/components/forms/extended/AutoCompleteForm/AutoCompleteForm";
import Button from "./shared/components/Button/Button";
import Checkbox from "./shared/components/Checkbox/checkbox";
import CheckboxButton from "./shared/components/CheckboxButton/checkbox-button";
import CiviliteSelectForm
	from "./shared/components/forms/extended/SelectForm/selects/CiviliteSelectForm/CiviliteSelectForm";
import Form from "./shared/components/forms/Form";
import InputCodePostalForm
	from "./shared/components/forms/extended/InputNumber/InputCodePostalForm/InputCodePostalForm";
import InputDate from "./shared/components/InputDate/input-date";
import InputDateForm from "./shared/components/forms/extended/InputDate/InputDate";
import InputDateFormCalendar from "./shared/components/forms/extended/InputDate/InputDateCalendar/InputDateCalendar";
import InputDecimalForm from "./shared/components/forms/extended/InputNumber/InputDecimalForm/InputDecimalForm";
import InputDefaultForm from "./shared/components/forms/default/InputDefaultForm";
import InputEmailForm from "./shared/components/forms/extended/InputText/InputEmailForm/InputEmailForm";
import InputNumber from "./shared/components/InputNumber/InputNumber";
import InputNumberForm from "./shared/components/forms/extended/InputNumber/InputNumberForm";
import InputSelect from "./shared/components/InputSelect/InputSelect";
import InputTelephoneForm from "./shared/components/forms/extended/InputNumber/InputTelephoneForm/InputTelephoneForm";
import InputText from "./shared/components/InputText/InputText";
import InputTextForm from "./shared/components/forms/extended/InputText/InputTextForm";
import InputTime from "./shared/components/InputTime/InputTime";
import Loader from "./shared/components/Loader/Loader";
import NotificationItem from "./shared/components/notification/notification-item/notification-item";
import NotificationList from "./shared/components/notification/notification-list/notification-list";
import NotificationListHeader from "./shared/components/notification/notification-list-header/notification-list-header";
import NotificationPanel from "./shared/components/notification/notification-panel/notification-panel";
import NotificationScroll from "./shared/components/notification/notification-scroll/notification-scroll";
import PanelPopup from "./shared/components/PanelPopup/PanelPopup";
import PaysSelectForm from "./shared/components/forms/extended/SelectForm/selects/PaysSelectForm/PaysSelectForm";
import SkeletonLarge from "./shared/components/Skeleton/SkeletonLarge/SkeletonLarge";
import SkeletonSmall from "./shared/components/Skeleton/SkeletonSmall/SkeletonSmall";
import SkeletonSubmit from "./shared/components/Skeleton/SkeletonSubmit/SkeletonSubmit";
import Scroll from "./shared/components/Scroll/Scroll";
import SelectForm from "./shared/components/forms/extended/SelectForm/SelectForm";
import TextareaForm from "./shared/components/forms/extended/Textarea/TextareaForm";
import Title from "./shared/components/Title/Title";
import VerticalScroll from "./shared/components/VerticalScroll/vertical-scroll";
import Pill from "./shared/components/Pill/Pill";

Vue.component("AutoCompleteForm", AutoCompleteForm);
Vue.component("Button", Button);
Vue.component("Pill", Pill);
Vue.component("Checkbox", Checkbox);
Vue.component("CheckboxButton", CheckboxButton);
Vue.component("CiviliteSelectForm", CiviliteSelectForm);
Vue.component("Form", Form);
Vue.component("InputCodePostalForm", InputCodePostalForm);
Vue.component("InputDate", InputDate);
Vue.component("InputDateForm", InputDateForm);
Vue.component("InputDateFormCalendar", InputDateFormCalendar);
Vue.component("InputDecimalForm", InputDecimalForm);
Vue.component("InputDefaultForm", InputDefaultForm);
Vue.component("InputEmailForm", InputEmailForm);
Vue.component("InputNumber", InputNumber);
Vue.component("InputNumberForm", InputNumberForm);
Vue.component("InputSelect", InputSelect);
Vue.component("InputTelephoneForm", InputTelephoneForm);
Vue.component("InputText", InputText);
Vue.component("InputTextForm", InputTextForm);
Vue.component("InputTime", InputTime);
Vue.component("Loader", Loader);
Vue.component("NotificationItem", NotificationItem);
Vue.component("NotificationList", NotificationList);
Vue.component("NotificationListHeader", NotificationListHeader);
Vue.component("NotificationPanel", NotificationPanel);
Vue.component("NotificationScroll", NotificationScroll);
Vue.component("PanelPopup", PanelPopup);
Vue.component("PaysSelectForm", PaysSelectForm);
Vue.component("Scroll", Scroll);
Vue.component("SelectForm", SelectForm);
Vue.component("SkeletonLarge", SkeletonLarge);
Vue.component("SkeletonSmall", SkeletonSmall);
Vue.component("SkeletonSubmit", SkeletonSubmit);
Vue.component("TextareaForm", TextareaForm);
Vue.component("Title", Title);
Vue.component("VerticalScroll", VerticalScroll);

@Component({
	components: {
		AutoCompleteForm: require("./shared/components/forms/extended/AutoCompleteForm/AutoCompleteForm.vue.html"),
		Button: require("./shared/components/Button/Button.vue.html"),
		Pill: require("./shared/components/Pill/Pill.vue.html"),
		Checkbox: require("./shared/components/Checkbox/checkbox.vue.html"),
		CheckboxButton: require("./shared/components/CheckboxButton/checkbox-button.vue.html"),
		CiviliteSelectForm: require("./shared/components/forms/extended/SelectForm/selects/CiviliteSelectForm/CiviliteSelectForm.vue.html"),
		Form: require("./shared/components/forms/Form.vue.html"),
		InputCodePostalForm: require("./shared/components/forms/extended/InputNumber/InputCodePostalForm/InputCodePostalForm.vue.html"),
		InputDate: require("./shared/components/InputDate/input-date.vue.html"),
		InputDateForm: require("./shared/components/forms/extended/InputDate/InputDate.vue.html"),
		InputDateFormCalendar: require("./shared/components/forms/extended/InputDate/InputDateCalendar/InputDateCalendar.vue.html"),
		InputDecimalForm: require("./shared/components/forms/extended/InputNumber/InputDecimalForm/InputDecimalForm.vue.html"),
		InputDefaultForm: require("./shared/components/forms/default/InputDefaultForm.vue.html"),
		InputEmailForm: require("./shared/components/forms/extended/InputText/InputEmailForm/InputEmailForm.vue.html"),
		InputNumber: require("./shared/components/InputNumber/InputNumber.vue.html"),
		InputNumberForm: require("./shared/components/forms/extended/InputNumber/InputNumberForm.vue.html"),
		InputSelect: require("./shared/components/InputSelect/InputSelect.vue.html"),
		InputTelephoneForm: require("./shared/components/forms/extended/InputNumber/InputTelephoneForm/InputTelephoneForm.vue.html"),
		InputText: require("./shared/components/InputText/InputText.vue.html"),
		InputTextForm: require("./shared/components/forms/extended/InputText/InputTextForm.vue.html"),
		InputTime: require("./shared/components/InputTime/InputTime.vue.html"),
		Loader: require("./shared/components/Loader/Loader.vue.html"),
		NotificationItem: require("./shared/components/notification/notification-item/notification-item.vue.html"),
		NotificationList: require("./shared/components/notification/notification-list/notification-list.vue.html"),
		NotificationListHeader: require("./shared/components/notification/notification-list-header/notification-list-header.vue.html"),
		NotificationPanel: require("./shared/components/notification/notification-panel/notification-panel.vue.html"),
		NotificationScroll: require("./shared/components/notification/notification-scroll/notification-scroll.vue.html"),
		PanelPopup: require("./shared/components/PanelPopup/PanelPopup.vue.html"),
		PaysSelectForm: require("./shared/components/forms/extended/SelectForm/selects/PaysSelectForm/PaysSelectForm.vue.html"),
		Scroll: require("./shared/components/Scroll/Scroll.vue.html"),
		SelectForm: require("./shared/components/forms/extended/SelectForm/SelectForm.vue.html"),
		SkeletonLarge: require("./shared/components/Skeleton/SkeletonLarge/SkeletonLarge.vue.html"),
		SkeletonSmall: require("./shared/components/Skeleton/SkeletonSmall/SkeletonSmall.vue.html"),
		SkeletonSubmit: require("./shared/components/Skeleton/SkeletonSubmit/SkeletonSubmit.vue.html"),
		TextareaForm: require("./shared/components/forms/extended/Textarea/TextareaForm.vue.html"),
		Title: require("./shared/components/Title/Title.vue.html"),
		VerticalScroll: require("./shared/components/VerticalScroll/vertical-scroll.vue.html")
	}
})
export class GlobalComponents extends Vue {
}



// WEBPACK FOOTER //
// ./src/globalComponents.ts